import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EditAIInferenceStreamVariables = Types.Exact<{
  input: Types.EditAIInferenceStreamInput;
}>;

export type EditAIInferenceStream = {
  editAIInferenceStream: Pick<
    Types.AIInferenceStream,
    | 'alias'
    | 'createdAt'
    | 'deleted'
    | 'deletedAt'
    | 'pinned'
    | 'private'
    | 'saved'
    | 'streamId'
    | 'streamName'
    | 'updatedAt'
    | 'userPrompt'
  > & {
    createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser>;
    deletedBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser>;
    updatedBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser>;
    usage?: Types.Maybe<
      Pick<
        Types.AIInferenceStreamUsage,
        | 'cacheCreationInputTokens'
        | 'cacheReadInputTokens'
        | 'inputTokens'
        | 'modelID'
        | 'outputTokens'
      >
    >;
  };
};

export const EditAIInferenceStreamDocument = gql`
  mutation EditAIInferenceStream($input: EditAIInferenceStreamInput!) {
    editAIInferenceStream(input: $input) {
      alias
      createdAt
      createdBy {
        ...ActorTeaser
      }
      deleted
      deletedAt
      deletedBy {
        ...ActorTeaser
      }
      pinned
      private
      saved
      streamId
      streamName
      updatedAt
      updatedBy {
        ...ActorTeaser
      }
      usage {
        cacheCreationInputTokens
        cacheReadInputTokens
        inputTokens
        modelID
        outputTokens
      }
      userPrompt
    }
  }
  ${ActorTeaser}
`;
export type EditAIInferenceStreamMutationFn = Apollo.MutationFunction<
  EditAIInferenceStream,
  EditAIInferenceStreamVariables
>;

/**
 * __useEditAIInferenceStream__
 *
 * To run a mutation, you first call `useEditAIInferenceStream` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAIInferenceStream` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAiInferenceStream, { data, loading, error }] = useEditAIInferenceStream({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAIInferenceStream(
  baseOptions?: Apollo.MutationHookOptions<EditAIInferenceStream, EditAIInferenceStreamVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EditAIInferenceStream, EditAIInferenceStreamVariables>(
    EditAIInferenceStreamDocument,
    options,
  );
}
export type EditAIInferenceStreamHookResult = ReturnType<typeof useEditAIInferenceStream>;
export type EditAIInferenceStreamMutationResult = Apollo.MutationResult<EditAIInferenceStream>;
export type EditAIInferenceStreamMutationOptions = Apollo.BaseMutationOptions<
  EditAIInferenceStream,
  EditAIInferenceStreamVariables
>;
export function mockEditAIInferenceStream({
  data,
  variables,
  errors,
}: {
  data: EditAIInferenceStream;
  variables?: EditAIInferenceStreamVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: EditAIInferenceStreamDocument, variables },
    result: { data, errors },
  };
}
